module.exports = __webpack_public_path__ + "img/webnew73.33131cdc.jpg";